<!--
@see https://app.clickup.com/2409014/v/dc/29ghp-6548/29ghp-6781
-->
<template>
	<div>
		<div>
			<h3>Source</h3>
			<MaterialNumber
				label="Clone from order"
				v-model="recipe.source_order_number"
				/>
		</div>

		<div
			v-if="!source"
			class="margin-top">
			<h3>From remote</h3>
			<p>
				Optionally, you can fetch the order data from a remote environment.
				If you leave this field blank the order will be cloned from <em>this</em> environment.
			</p>
			<div class="flex margin-top">
				<MaterialText
					v-model="recipe.from_remote"
					label="From API"
					/>
				<button
					class="small gray xs-margin-left"
					v-on:click="recipe.from_remote = `${api_url_prod}`">
					Production
				</button>
				<button
					class="small gray xs-margin-left"
					v-on:click="recipe.from_remote = `${api_url_staging}`">
					Staging
				</button>
				<button
					class="small gray xs-margin-left"
					v-on:click="recipe.from_remote = `${api_url_canary}`">
					Canary
				</button>
				<button
					v-if="recipe.from_remote"
					class="small gray xs-margin-left"
					v-on:click="recipe.from_remote = ''">
					X
				</button>
			</div>
			<div class="note xs-margin-top">
				Example: {{api_url}}
			</div>
		</div>

		<div
			class="margin-top">
			<h3>Customer</h3>
			<MaterialToggle
				v-model="recipe.same_customer"
				label="Same customer"
				/>
			<div
				v-if="recipe.same_customer && recipe.from_remote"
				class="small-margin-top"
				style="color: red">
				When using a remote source, you cannot use <strong>same customer</strong>
			</div>
		</div>

		<div
			v-if="!recipe.same_customer"
			class="margin-top">
			<CustomerSearch
				v-model="recipe.customer"
				/>
		</div>

		<div
			v-if="recipe.customer && !recipe.same_customer">
			<strong>Selected customer:</strong>
			{{ recipe.customer.full_name }} ({{ recipe.customer.id }})
		</div>

		<div
			class="margin-top">
			<h3>What to import</h3>
			<div v-for="(flag, f) in recipe.import_flags">
				<MaterialToggle
					v-model="recipe.import_flags[f]"
					:label="parseImportFlagTitle(f)" />
			</div>
		</div>

		<div
			class="margin-top">
			<h3>Other settings</h3>
			<MaterialToggle
				v-model="recipe.manage_stock_add"
				label="Manage stock when adding products"
				/>
			<MaterialToggle
				v-model="recipe.cancel_source"
				label="Cancel source order"
				note="Only possible on same environment"
				/>
			<MaterialToggle
				v-model="recipe.remove_products_on_source"
				label="Remove products on source order"
				note="Only possible on same environment"
				/>
		</div>

		<div class="margin-top">
			<button
				:disabled="saving"
				v-on:click="clone">Clone</button>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
export default {
  props: {
    source: {
      default: ''
    }
  },
  data: () => ({
    saving: false,
    recipe: {
      source_order_number: '',
      from_remote: '',
      same_customer: true,
      customer: null,
      manage_stock_add: true,
      cancel_source: true,
      remove_products_on_source: true,
      import_flags: {
        IMPORT_PRODUCTS: true,
        IMPORT_PRESHIPPING: true,
        IMPORT_TRACKING: true,
        IMPORT_DISCOUNTS: true,
        IMPORT_RETURN_STATUS: true,
        IMPORT_ORDER_LETTER: true,
        IMPORT_FEEDBACK: true,
        IMPORT_PAYMENT_PLAN: true,
        IMPORT_OUTFITS: true,
        IMPORT_DEPOSIT: true,
        IMPORT_AI_DECOMPOSITION_KEEP: true,
        IMPORT_AI_DECOMPOSITION_REMOVE: false,
        IMPORT_AI_CUSTOMER_COMMENT: true,
        IMPORT_QUIZ_LIKES: true
      }
    },
    api_url_prod: process.env.VUE_APP_PRODUCTION_API_URL,
    api_url_staging: process.env.VUE_APP_STAGING_API_URL,
    api_url_canary: process.env.VUE_APP_CANARY_API_URL,
    api_url: process.env.VUE_APP_API_URL
  }),
  methods: {
    clone () {
      Vue.$api.post('/clone', this.recipe, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.afterClone(data)
      })
    },
    afterClone (data) {
      this.$router.push('/order/' + data.id)
    },
    parseImportFlagTitle (key) {
      var str = key.replace(/^IMPORT_/, '')
        .replace(/_/g, ' ')
        .toLowerCase()

      return str.substr(0, 1).toUpperCase() + str.substr(1)
    }
  },
  created () {
    this.recipe.source_order_number = this.source
  }
}
</script>
